<template>
<div>
  <div>
    <div class="box" v-bind:style="background">
      <div class="container title-container">
        <div class="row">
          <span class="title-box">
            <h1 class="title">CONSTRUCTION</h1>
          </span>
          <span class="message-background">
            <h2 class="message">各種プラントの組立、解体及び骨材ストックヤード（特許工法）の設置、リースを中心に、特殊シールドの据付や工場の移転まで。</h2>
          </span>
        </div>
      </div>
    </div>
    <div class="head-line business">
    <p>  事業内容</P>
    </div>
    <div class="container-fluid content">
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/const-content-3.png"/>
        </div>
        <div class="col-xs-12 col-lg-5 order-md-first disc">
          <div class="table-container">
            <div class="table-title text">
              輸送から組立・解体・保管まで、当社が一貫して行っております。
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <td class="text">当社では1971年の成田空港道路建設において大型アスファルトプラントの建設を行いました。<br>以来50年以上高速道路や滑走路の建設現場で、アスファルトプラント、ソイルプラントの輸送・組立・解体・保管、及び当社の特許工法である骨材ストックヤードの設置及びリースを行っております。</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="head-line achive">
    <p> 工事実績</p>
    </div>
    <div class="container-fluid content">
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/const-content-4.png"/>
        </div>
        <div class="col-xs-12 col-lg-5 resizeimage disc">
          <div class="table-container">
            <div class="table-title text">
              <div class="table-caption">
                高速道路事業
              </div>
              全国の高速道路360工区以上の現場で、プラント・ヤードの組立・解体を行ってまいりました。
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <td class="small-text">近年のプラント工事およびプラントリース実績
                    【高速道路】
                    ・北海道横断自動車道余市小樽舗装工事(2017-2018)
                    ・新東名高速道路伊勢原、伊勢原北IC-秦野IC間、海老名IC-秦野北間の各舗装工事(2020-2022)
                    ・新名神高速道路 高槻、箕面、川西、神戸、菰野の各舗装工事(2016-2019)
                    ・東京外環自動車道 松戸、高谷の各舗装工事(2016-2018)
                    ・中部横断自動車道 六郷-増穂、新清水-富沢の各舗装工事(2016-2019)
                    ・首都圏中央連絡自動車道（圏央道） 稲敷、成田、常総、桶川、幸手、坂東西、坂東の各舗装工事(2013-2016)
                    ・東北中央自動車道 南陽、上山の各舗装工事(2017-2019)
                    ・館山自動道 富津舗装工事（2017-2018）
                    ・東関東自動車道 鉾田舗装工事（2016-2017）
                    ・常磐自動車道 楢葉-富岡間舗装工事(2019-2020)、いわき、双葉、広野、山元IC-岩沼IC間の各工事(2020-2021)
                    ・上信越自動車道 上越舗装工事(2017-2018)
                    ・東海北陸自動車道 郡上、高山の各舗装工事(2017-2019)
                    ・東海環状自動車道 関広見舗装工事(2019-2020)
                    ・南阪奈道路 竹内舗装工事(2019-2020)
                    ・近畿自動車道紀勢線湯浅御坊道路 日高川、広川の各舗装工事（2020-2022)
                    ・舞鶴若狭自動車道 福知山舗装工事(2020-2021)
                    ・阪和自動車道 御坊舗装工事(2020-2022)
                    ・中国横断自動車道 たつの舗装工事(2020-2022)
                    ・首都圏中央連絡自動車道（圏央道）白岡-坂東間舗装工事(2022-2023)
                    ・首都圏中央連絡自動車道（圏央道）つくば牛久舗装工事(2024-2025)
                    ・佐世保道路 相浦舗装工事(2024-2025)
                    ・新東名高速道路 新秦野-萱沼トンネル間コンクリート舗装版工事(2024-2027)
                    ・東海環状自動車道 山県IC-糸貫IC間舗装工事(2024-2025)
                    ・新東名高速道路 谷ヶ山トンネル-新御殿場IC間舗装工事(2024-2025)
                    ・首都圏中央連絡自動車道（圏央道） 阿見稲敷、成田、神崎大栄、横芝光の各舗装工事(2024-2027)

                    【ソイルプラントリース】
                    ・圏央道 海老名舗装工事(2012-2013)
                    ・東九州自動車道 苅田舗装工事(2013-2014)、行橋舗装工事(2014)
                    ・東海北陸自動車道 郡上舗装工事(2017-2019)
                    ・常磐自動車道 いわき舗装工事（2020-2021）
                    ・新東名高速道路 新秦野-萱沼トンネル間コンクリート舗装版工事(2024-2026)</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid content">
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/const-content-5.png"/>
        </div>
        <div class="col-xs-12 col-lg-5 order-md-first disc">
          <div class="table-container">
            <div class="table-title text">
              <div class="table-caption">
                滑走路事業
              </div>
              滑走路建設・修繕工事にて大規模なプラントの設置を行い、
              工事計画の進捗を支援します。
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <td class="text">近年の滑走路建設の工事実績
                  【空港】
                    ・羽田空港 国際線滑走路建設工事(2009-2010)
                    ・岩国空港 路盤工事（2008、2012、2013）
                    ・静岡空港 舗装工事（2007-2008）
                    ・関西空港 A滑走路舗装工事(2021-2022)
                    ・関西空港 B滑走路嵩上げ工事(2022-2023)</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid content">
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/const-content-6.png"/>
        </div>
        <div class="col-xs-12 col-lg-5 resizeimage disc">
          <div class="table-container">
            <div class="table-title text">
              <div class="table-caption">
                輸送事業
              </div>
              プラント機材の輸送トレーラーを20セット保有。
              重量物輸送事業を行う当社は、資材の搬入出も承ります。
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <td class="small-text">近年の主な輸送実績
                  ・新東名高速道路  伊勢原北IC-秦野IC間舗装工事（2022）
                    アスファルトプラント材等  トレーラー40台
                  ・近畿自動車道紀勢線湯浅御坊道路  広川舗装工事（2022）
                    ストックヤード材等  トラック12台
                  ・阪和自動車道  御坊舗装工事（2022）
                    アスファルトプラント材等  トレーラー52台

                    他多数</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="container contact-container">
      <div class="row office-box">
        <div class="col-xs-12 col-lg-6 contact">
          <span>本社工事部</span>
          〒339-0011 埼玉県さいたま市岩槻区長宮77
          T:048-799-1212｜F:048-799-0623
        </div>
        <div class="col-xs-12 col-lg-6 contact">
          <span>機材センター</span>
          〒339-0011 埼玉県さいたま市岩槻区長宮102 他
            プラント保管14,000m2
        </div>
      </div>
    </div>
  </div>
  <script type="application/ld+json">
    {
      "@context": "http://schema.org/",
      "@type": "JobPosting",
      "title": "プラント工事リーダー・スタッフ",
      "description": "<p>現場での機械組立て・解体の現場監督・スタッフを募集！</p>\n<p>主に実施していただくのはアスファルトプラントの組立・解体となり、4〜8名のチームで、およそ2週間かけて取り組んでいく作業です。<br>\n工事の最初から最後まで携わるため、組立・解体後に味わう達成感はひとしお。<br>\n「仕事をやりきった」という実感が、大きなやりがいに繋がります。<br>\n勤務は8時〜17時で、残業が発生することはほとんどなし。<br>\nゆとりある環境のもと、のびのびとご活躍ください</p>",
      "datePosted": "2020-12-01",
      "validThrough": "2021-06-01",
      "employmentType": "FULL_TIME",
      "hiringOrganization": {
        "@type": "Organization",
        "name": "東栄運輸株式会社",
        "sameAs": "https://www.toei.myweb.co.jp/"
      },
      "jobLocation": {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "addressRegion": "埼玉県",
          "addressLocality": "さいたま市",
          "streetAddress": "岩槻区長宮77",
          "postalCode": "339-0011",
          "addressCountry": "JP"
        }
      },
      "baseSalary": {
        "@type": "MonetaryAmount",
        "currency": "JPY",
        "value": {
          "@type": "QuantitativeValue",
          "value": "260000",
          "minValue": "260000",
          "maxValue": "350000",
          "unitText": "MONTH"
        }
      }
    }
  </script>
</div>
</template>

<script>
export default {
  data () {
    return {
      background: {
        background: '',
        position: 'relative',
        height: '100vh',
        minHeight: '300px',
        backgroundSize: 'cover',

        display: 'flex',
        flexDirection: 'column',

        letterSpacing: '0',
        color: '#FFFFFF'
      },
      title: 'CONSTRUCTION',
      message: '各種プラントの組立、解体、保管を中心に、特殊シールドの据付や工場の移転まで。'
    }
  },
  created () {
    this.background.background = "url('" + require('../assets/construction.jpg') + "') no-repeat center center"
  }
}
</script>

<style scoped>
.content {
  padding-top: 5%;
  max-width: 1280px;
}
.table-container {
  padding: 2% 4% 4% 4%;
  white-space: pre-line;
}
.head-line {
  margin-top: 30px;
  height: 40px;
  width: 20%;
  background-image: linear-gradient(90deg,rgba(71,62,60,1),rgba(255,255,255,1));
}
.head-line p{
  margin: 2px;
  padding: 8px 2px 2px 8px;
  color: #FFFFFF;
}
.table-container.last {
  padding-bottom: 40px;
}
.table td {
  color: #000000;
  vertical-align: middle;
}
.table th {
  font-size: 24px;
  color: #000000;
  vertical-align: middle;
}
.type-table {
  font-size: 24px;
}
.type-table td{
  font-size: 24px;
  text-align: end;
}
@media screen and (max-width: 1280px) {
  .type-table td {
    font-size: 20px;
    padding-left: 0;
    padding-right: 0;
  }
  .type-table th {
    font-size: 20px;
  }
}
.table a{
  font-size: 16px;
}
.table .no-border {
  border-top: none;
}
.text {
  font-size: 16px;
}
.small-text {
  font-size: 12px;
}
.table-title {
  color: #000000;
  font-size: 30px;
  font-weight: bold;
  padding-bottom: 20px;
  position: relative;
}
.table-caption {
  position: absolute;
  top: -16%;
  font-size: 16px;
  color: #6F6B6B;
  font-weight: normal;
}
.box4 {
  border: 2px solid #7E7474;
  padding: 5px 14px;
  margin-top: 20px;
  margin-bottom: 11px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  right: 9px;
  bottom: 27px;
  min-width: 170px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box4 p {
  font-size: 20px!important;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
}
.arrow01 {
  display: block;
  width: 12px;
  height: 12px;
  border-top: solid 3px #7E7474;
  border-right: solid 3px #7E7474;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  right: 13%;
}
.caption {
  position: absolute;
  top: 0%;
  font-size: 16px;
  color: #6F6B6B;
  font-weight: normal;
}
.resizeimage {
  padding-right: 0px;
  padding-left: 0px;
  text-align: end;
  min-width: 240px;
}
.resizeimage img {
  width: 100%;
}
.resizeimage a {
  font-size: 10px;
  padding-right: 2%;
}
.disc {
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: left;
}
.disc-caption {
  text-align: end;
}
.contact-container {
  padding-top: 40px;
  padding-bottom: 40px;
  white-space: pre-line;
  position: relative;
}
.contact-box {
  border: 2px solid #7E7474;
  display: flex;
  padding: 25px 20px 25px 20px;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 20px;
  margin-bottom: 11px;
  margin-left: 0px;
  margin-right: 0px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  right: 9px;
  bottom: 27px;
  min-width: 170px;
  text-align: center;
}
.contact-box p {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
  text-align: left;
}
.contact-box p.tel {
  font-size: 36px;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
}
.office-box {
  padding: 0px 10% 0px 12%;
}
@media screen and (max-width: 480px) {
  .head-line {
    width: 35%;
  }
  .office-box {
    padding: 0px 0px 0px 0px;
  }
  .contact {
    padding-top: 12px;
    padding-bottom: 12px;
    font-size: 16px;
  }
  .contact span {
    font-size: 17px;
  }
  .resizeimage {
    padding-right: 5%;
    padding-left: 5%;
  }
  .table-title {
    font-size: 21px;
  }
}
.contact {
  padding-top: 12px;
  padding-bottom: 12px;
}
.contact span {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
}
.message-background {
  background: #333333 0% 0% no-repeat padding-box;
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 14.5px;
  padding-right: 14.5px;
  position: absolute;
  bottom: 40px;
  margin: 20px;
}
.title {
  top: 106px;
  left: 64px;
  font-size: 76px;
  font-weight: 700;
  letter-spacing: 0;
  border-bottom: solid;
  color: #0A0909;
  opacity: 1;
  position: absolute;
  top: 45px;
  left: 20px;
}
@media screen and (max-width:600px) {
  .message-background {
    background: #333333 0% 0% no-repeat padding-box;
    padding-top: 7px;
    padding-bottom: 7px;
    padding-left: 14.5px;
    padding-right: 14.5px;
    position: absolute;
    bottom: 40px;
    margin: 20px;
  }
  .title {
    top: 106px;
    left: 64px;
    font-size: 40px;
    font-weight: 700;
    letter-spacing: 0;
    border-bottom: solid;
    color: #0A0909;
    opacity: 1;
    position: absolute;
    top: 45px;
    left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Construction.vue